import React from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from '@techstyle/react-intl';

import toastWrapper from '../../hoc/toastWrapper';
import { Component as AddToCartButton } from '../AddToCartButton';
import VipBoxRegistrationModal from '../VipBoxRegistrationModal/VipBoxRegistrationModal';

class VipBoxButton extends React.PureComponent {
  static propTypes = {
    alternate: PropTypes.bool,
    secondary: PropTypes.bool,
    white: PropTypes.bool,
    profile: PropTypes.object,
    isVisitor: PropTypes.bool,
    loadProfile: PropTypes.func,
    onRequestSubscribe: PropTypes.func,
  };

  static defaultProps = {
    alternate: false,
    secondary: false,
    white: false,
  };

  state = {
    showVipBoxModal: false,
    subscribing: false,
  };

  handleSubscribe = async email => {
    const { onRequestSubscribe, profile } = this.props;

    this.setState({
      subscribing: true,
    });

    const attributes = {
      waitlist: 'Xtra VIP Box',
    };

    const emailUsed = profile.email ? profile.email : email;
    let error;

    try {
      await onRequestSubscribe({ email: emailUsed, attributes });
    } catch (err) {
      error = err;
    }
    this.setState({
      subscribing: false,
    });

    if (this.state.showVipBoxModal) {
      this.setState({
        showVipBoxModal: false,
      });
    }

    if (error) {
      return this.props.showToastMessage(
        <FormattedMessage
          id="vip_box_registration.toast_failure_message"
          defaultMessage="Oops we’ve encountered an error. Try again"
        />
      );
    }

    return this.props.showToastMessage(
      <FormattedMessage
        id="vip_box_registration.toast_success_message"
        defaultMessage="Congrats! You’re on the list. Don’t forget to check out what’s new before it’s gone!"
      />
    );
  };

  handleClick = async () => {
    let { isVisitor, profile } = this.props;

    // If logged in but `profile` appears unpopulated, try to fetch it.
    if (!isVisitor && !profile.email) {
      await this.props.loadProfile();
      // The component's props should be updated immediately, but make sure to
      // reference the fresh value on `props` and not the already-captured
      // `profile` above.
      profile = this.props.profile;
    }

    return this.toggleVipBoxModal();
  };

  toggleVipBoxModal = () => {
    const { showVipBoxModal } = this.state;

    if (!showVipBoxModal && this.props.trackPDPshowVipBoxModalEvent) {
      this.props.trackPDPshowVipBoxModalEvent();
    }
    this.setState({ showVipBoxModal: !showVipBoxModal });
  };

  render() {
    const { alternate, secondary, white, className, children } = this.props;
    return (
      <>
        <AddToCartButton
          data-autotag="pdp-let-me-know-button"
          className={className}
          onClick={this.handleClick}
          disabled={this.state.subscribing}
          alternate={alternate}
          secondary={secondary}
          white={white}
        >
          {children || (
            <FormattedMessage
              id="site_pdp.xtra_vip_cta"
              defaultMessage="Let Me Know"
            />
          )}
        </AddToCartButton>
        <VipBoxRegistrationModal
          isOpen={this.state.showVipBoxModal}
          onRequestClose={this.toggleVipBoxModal}
          onRequestSubscribe={this.handleSubscribe}
          subscribing={this.state.subscribing}
        />
      </>
    );
  }
}

export default toastWrapper(VipBoxButton);
